export default "__VITE_ASSET__BOeil4Zz__"